import { render, staticRenderFns } from "./IconMove.vue?vue&type=template&id=604bd617&"
import script from "./IconMove.vue?vue&type=script&lang=js&"
export * from "./IconMove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports